module.exports = __webpack_public_path__ + "static/media/chz.df3468f9.svg";